import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_LOANS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_LOAN:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_LOAN:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    // return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_LOAN:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    // return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_LOAN:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
